<template>
    <div class="formDFD">
        <div class="form mb-3" style="min-height: 20vh;" v-if="lstEtapas">
            <div class="row">
                <div class="col-12 text-end mb-2">
                    <div v-if="emProcessamento" class="importacao-em-andamento-container">
                        <div class="importacao-em-andamento-card">
                            <div class="row">
                                <div class="col-12 col-md-2 m-auto">
                                    <div class="importacao-em-andamento-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M8 3a5 5 0 1 0 4.546 7.083.5.5 0 0 1 .908.418A6 6 0 1 1 8 2v1z" />
                                            <path d="M8 0a.5.5 0 0 1 .5.5V4a.5.5 0 0 1-1 0V.5A.5.5 0 0 1 8 0z" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="col-12 col-md-8 text-start">
                                    <h2>Processamento em andamento</h2>
                                    <p class="text-start">Existe um processamento em andamento. Aguarde a conclusão para gerar o documento.</p>
                                    <p v-if="podeCancelarProcessamento" class="text-start text-warning mb-0">
                                        O processamento parece travado. Você pode cancelá-lo e tentar novamente.
                                    </p>
                                </div>
                                <div class="col-12 col-md-2  m-auto">
                                    <div class="importacao-em-andamento-actions d-flex flex-column gap-2">
                                        <button class="btn btn-primary" @click="getStatusProcessamento">
                                            <span>Recarregar status</span>
                                        </button>
                                        <button v-if="podeCancelarProcessamento"
                                                class="btn btn-outline-warning"
                                                :disabled="cancelarProcessamentoLoading"
                                                @click="confirmarCancelarProcessamento">
                                            {{ cancelarProcessamentoLoading ? 'Cancelando...' : 'Cancelar processamento' }}
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <button v-if="!emProcessamento"
                            :class="(flPermissao?'btn btn-outline-primary':'btn btn-outline-light')"
                            @click="(flPermissao?buscarNoPncp():null)"
                            :disabled="!flPermissao">
                        Buscar no PNCP
                    </button>
                    <button v-if="!emProcessamento && temRequisicaoCompra"
                            :class="(flPermissao?'btn btn-outline-primary ms-3':'btn btn-outline-light ms-3')"
                            @click="(flPermissao?preencherPorRequisicao():null)"
                            :disabled="!flPermissao">
                        Preencher a partir da Requisição
                    </button>
                    <button v-if="!emProcessamento"
                            :class="(flPermissao?'btn btn-primary ms-3':'btn btn-outline-light ms-3')"
                            @click="(flPermissao?preencherIA():null)"
                            :disabled="!flPermissao">
                        Preencher com IA
                    </button>
                </div>
            </div>
            <div class="dfd-conteudo" :class="{ 'dfd-conteudo--com-pncp': painelPncpAberto }">
                <div class="dfd-formulario">
                    <div class="wizard-indicators mb-4">
                        <div class="wizard-step"
                             v-for="(item, index) in lstEtapas"
                             :key="index"
                             :class="{active: index === indexFormulario,obrigatoria: index === indexUltimaEtapaAvancada,completed: index < indexUltimaEtapaAvancada}"
                             @click="navegarParaEtapa(index)">
                            <div class="circle">{{ index + 1 }}</div>
                            <div class="label">{{ item.dsTitulo }}</div>
                            <div class="line" v-if="index < lstEtapas.length - 1"></div>
                        </div>
                    </div>
                    <div class="carousel-inner pb-5">
                <div :class="'carousel-item '+ (indexFormulario == 0?'active':'')">
                    <h5>I - Justificativa da Necessidade da Contratação</h5>
                    <span class="d-none">SubTitulo</span>

                    <div class="form-group px-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(23)+'-0'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(23)+'-0'">
                            1 - Qual a necessidade ou problema que será atendido com esta contratação?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(23)+'-0']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(23)+'-0'" :name="getIdModeloArtefatoFormularioEtapa(23)+'-0'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(23)+'-0']"
                                  placeholder=""></textarea>

                        <span class="d-none">dsExemplo</span>
                    </div>

                    <div class="form-group px-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(23)+'-1'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(23)+'-1'">
                            2 - Como essa necessidade está alinhada aos objetivos estratégicos do órgão ou entidade?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(23)+'-1']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(23)+'-1'" :name="getIdModeloArtefatoFormularioEtapa(23)+'-1'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(23)+'-1']"
                                  placeholder=""></textarea>

                        <span class="d-none">dsExemplo</span>
                    </div>
                </div>

                <div :class="'carousel-item '+ (indexFormulario == 1?'active':'')">
                    <h5>II - Descrição Sucinta do Objeto</h5>
                    <span class="d-none">SubTitulo</span>

                    <div class="form-group px-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(24)+'-0'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(24)+'-0'">
                            3 - Qual o objeto da contratação?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(24)+'-0']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(24)+'-0'" :name="getIdModeloArtefatoFormularioEtapa(24)+'-0'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(24)+'-0']"
                                  placeholder=""></textarea>

                        <span class="d-none">dsExemplo</span>
                    </div>
                </div>

                <div :class="'carousel-item '+ (indexFormulario == 2?'active':'')">
                    <h5>III - Quantidade a Ser Contratada</h5>
                    <span class="d-none">SubTitulo</span>

                    <div class="form-group px-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(25)+'-0'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(25)+'-0'">
                            4 - Qual a quantidade estimada a ser contratada?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(25)+'-0']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(25)+'-0'" :name="getIdModeloArtefatoFormularioEtapa(25)+'-0'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(25)+'-0']"
                                  placeholder=""></textarea>

                        <span v-if="itensDetalhados == null || itensDetalhados.length == 0">Dica: Cadastre os itens do processo para que a quantidade seja carregada automaticamente.</span>
                    </div>

                    <div class="form-group px-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(25)+'-1'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(25)+'-1'">
                            5 - Qual foi o método utilizado para calcular a quantidade necessária?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(25)+'-1']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(25)+'-1'" :name="getIdModeloArtefatoFormularioEtapa(25)+'-1'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(25)+'-1']"
                                  placeholder=""></textarea>

                        <span class="d-none">dsExemplo</span>
                    </div>
                </div>

                <div :class="'carousel-item '+ (indexFormulario == 3?'active':'')">
                    <h5>IV - Estimativa Preliminar do Valor</h5>
                    <span class="d-none">SubTitulo</span>

                    <div class="form-group px-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(26)+'-0'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(26)+'-0'">
                            6 - Qual a estimativa preliminar do valor da contratação?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(26)+'-0']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(26)+'-0'" :name="getIdModeloArtefatoFormularioEtapa(26)+'-0'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(26)+'-0']"
                                  placeholder=""></textarea>

                        <span class="d-none">dsExemplo</span>
                    </div>

                    <div class="form-group px-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(26)+'-1'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(26)+'-1'">
                            7 - Quais fontes foram consultadas para estimar o valor?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(26)+'-1']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(26)+'-1'" :name="getIdModeloArtefatoFormularioEtapa(26)+'-1'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(26)+'-1']"
                                  placeholder=""></textarea>

                        <span class="d-none">dsExemplo</span>
                    </div>
                </div>

                <div :class="'carousel-item '+ (indexFormulario == 4?'active':'')">
                    <h5>V - Data Pretendida para Conclusão</h5>
                    <span class="d-none">SubTitulo</span>

                    <div class="form-group px-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(27)+'-0'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(27)+'-0'">
                            8 - Qual é a data pretendida para a conclusão da contratação?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(27)+'-0']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(27)+'-0'" :name="getIdModeloArtefatoFormularioEtapa(27)+'-0'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(27)+'-0']"
                                  placeholder=""></textarea>

                        <span class="d-none">dsExemplo</span>
                    </div>

                    <div class="form-group px-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(27)+'-1'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(27)+'-1'">
                            9 - Existe urgência na contratação?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(27)+'-1']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(27)+'-1'" :name="getIdModeloArtefatoFormularioEtapa(27)+'-1'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(27)+'-1']"
                                  placeholder=""></textarea>

                        <span class="d-none">dsExemplo</span>
                    </div>
                </div>

                <div :class="'carousel-item '+ (indexFormulario == 5?'active':'')">
                    <h5>VI - Grau de Prioridade</h5>
                    <span class="d-none">SubTitulo</span>

                    <div class="form-group px-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(28)+'-0'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(28)+'-0'">
                            10 - Qual o grau de prioridade desta contratação
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(28)+'-0']) }"
                                  rows="2"
                                  id="getIdModeloArtefatoFormularioEtapa(28)+'-0'" :name="getIdModeloArtefatoFormularioEtapa(28)+'-0'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(28)+'-0']"
                                  placeholder=""></textarea>

                        <span class="d-none">dsExemplo</span>
                    </div>

                    <div class="form-group px-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(28)+'-1'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(28)+'-1'">
                            11 - Justifique o grau de prioridade atribuído.
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(28)+'-1']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(28)+'-1'" :name="getIdModeloArtefatoFormularioEtapa(28)+'-1'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(28)+'-1']"
                                  placeholder=""></textarea>

                        <span class="d-none">dsExemplo</span>
                    </div>
                </div>

                <div :class="'carousel-item '+ (indexFormulario == 6?'active':'')">
                    <h5>VII - Vinculação ou Dependência</h5>
                    <span class="d-none">SubTitulo</span>

                    <div class="form-group px-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(29)+'-0'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(29)+'-0'">
                            12 - Esta contratação está vinculada ou depende de outro DFD para sua execução?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(29)+'-0']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(29)+'-0'" :name="getIdModeloArtefatoFormularioEtapa(29)+'-0'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(29)+'-0']"
                                  placeholder=""></textarea>

                        <span class="d-none">dsExemplo</span>
                    </div>

                    <div class="form-group px-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(29)+'-1'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(29)+'-1'">
                            13 - Qual a sequência necessária para a execução das contratações vinculadas?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(29)+'-1']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(29)+'-1'" :name="getIdModeloArtefatoFormularioEtapa(29)+'-1'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(29)+'-1']"
                                  placeholder=""></textarea>

                        <span class="d-none">dsExemplo</span>
                    </div>
                </div>

                <div :class="'carousel-item '+ (indexFormulario == 7?'active':'')">
                    <h5>VIII - Área Requisitante</h5>
                    <span class="d-none">SubTitulo</span>

                    <div class="form-group px-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(30)+'-0'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(30)+'-0'">
                            14 - Qual é a área requisitante ou técnica responsável por esta solicitação?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(30)+'-0']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(30)+'-0'" :name="getIdModeloArtefatoFormularioEtapa(30)+'-0'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(30)+'-0']"
                                  placeholder=""></textarea>

                        <span class="d-none">dsExemplo</span>
                    </div>

                    <div class="form-group px-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(30)+'-1'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(30)+'-1'">
                            15 - Quem é o responsável técnico pela demanda?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(30)+'-1']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(30)+'-1'" :name="getIdModeloArtefatoFormularioEtapa(30)+'-1'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(30)+'-1']"
                                  placeholder=""></textarea>

                        <span class="d-none">dsExemplo</span>
                    </div>
                </div>

                <div :class="'carousel-item '+ (indexFormulario == 8?'active':'')">
                    <h5>IX - Demonstrativo dos resultados pretendidos, em termos de economicidade e de melhor aproveitamento dos recursos humanos, materiais e financeiros disponíveis;</h5>
                    <span>Economicidade e aproveitamento de recursos</span>

                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(46)+'-0'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(46)+'-0'">
                            16 - Quais resultados o órgão espera alcançar com essa contratação?
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(46)+'-0'" :name="getIdModeloArtefatoFormularioEtapa(46)+'-0'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(46)+'-0']"
                                  placeholder=""></textarea>
                        <span>Descreva os benefícios diretos em termos de impacto no negócio, como melhoria no atendimento ao cidadão, maior eficiência ou redução de custos.</span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(46)+'-1'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(46)+'-1'">
                            17 - Como a contratação resolverá o problema ou atenderá à necessidade identificada no tópico I?
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(46)+'-1'" :name="getIdModeloArtefatoFormularioEtapa(46)+'-1'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(46)+'-1']"
                                  placeholder=""></textarea>
                        <span>Explique como o resultado impactará positivamente as atividades do órgão.</span>
                    </div>
                </div>
                    </div>
                    <div class="row align-items-center">
                        <div class="col-6 text-start">
                            <button class="btn btn-light me-3" v-if="indexFormulario > 0" @click="indexFormulario -=1">Anterior</button>
                        </div>
                        <div class="col-6 text-end">
                            <button class="btn btn-light ms-3"
                                    @click="irParaProximaEtapa"
                                    v-if="indexFormulario < (lstEtapas.length -1)">
                                Próximo
                            </button>
                        </div>
                        <div class="col-12 text-center mt-3">
                            <button :class="(flPermissao?'btn btn-primary ms-3':'btn btn-outline-light ms-3')"
                                    @click="(flPermissao?salvaForm():null)"
                                    :disabled="!flPermissao">
                                Salvar Formulário
                            </button>
                        </div>
                    </div>
                </div>
                <div v-if="painelPncpAberto" class="dfd-painel-pncp">
                    <div class="dfd-painel-pncp-header">
                        <div>
                            <h6 class="dfd-painel-pncp-titulo">
                                Resultados do PNCP
                                <span v-if="loadingPncp"
                                      class="spinner-border spinner-border-sm text-primary dfd-painel-pncp-header-spinner"
                                      role="status"
                                      aria-label="Buscando no PNCP"></span>
                            </h6>
                            <p class="dfd-painel-pncp-subtitulo">
                                {{ loadingPncp ? 'Buscando no PNCP...' : 'Clique em uma opção para preencher o objeto' }}
                            </p>
                        </div>
                        <div class="dfd-painel-pncp-acoes">
                            <button v-if="buscaPncpConcluida && !loadingPncp"
                                    type="button"
                                    class="btn btn-outline-primary btn-sm"
                                    :disabled="!flPermissao"
                                    @click="buscarNovamentePncp">
                                Buscar novamente
                            </button>
                            <button type="button"
                                    class="dfd-painel-pncp-fechar"
                                    title="Fechar"
                                    aria-label="Fechar painel PNCP"
                                    @click="fecharPainelPncp">
                                &times;
                            </button>
                        </div>
                    </div>

                    <div v-if="loadingPncp" class="dfd-painel-pncp-loading">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Carregando...</span>
                        </div>
                        <p class="mt-3 mb-0">Buscando no PNCP...</p>
                    </div>

                    <div v-else class="dfd-painel-pncp-resultado">
                        <div v-if="temResultadosPncp" class="dfd-pncp-grupos">
                            <template v-for="(grupo, grupoIndex) in lstObjetosPncp">
                                <section v-if="grupo.resultados && grupo.resultados.length"
                                         :key="'pncp-grupo-' + grupoIndex"
                                         class="dfd-pncp-grupo"
                                         :class="{ 'is-open': grupoPncpAberto(grupoIndex) }">
                                    <button type="button"
                                            class="dfd-pncp-grupo-titulo"
                                            :aria-expanded="grupoPncpAberto(grupoIndex) ? 'true' : 'false'"
                                            @click="alternarGrupoPncp(grupoIndex)">
                                        <span class="dfd-pncp-grupo-titulo-texto">{{ formatarNomeGrupoPncp(grupo.nome) }}</span>
                                        <span class="dfd-pncp-grupo-meta">{{ grupo.resultados.length }}</span>
                                        <span class="dfd-pncp-grupo-chevron" aria-hidden="true"></span>
                                    </button>
                                    <div v-show="grupoPncpAberto(grupoIndex)"
                                         class="dfd-pncp-lista"
                                         role="listbox"
                                         :aria-label="formatarNomeGrupoPncp(grupo.nome)">
                                        <button v-for="(opcao, opcaoIndex) in grupo.resultados"
                                                :key="'pncp-opcao-' + grupoIndex + '-' + opcaoIndex"
                                                type="button"
                                                class="dfd-pncp-opcao"
                                                role="option"
                                                :aria-selected="chaveObjetoPncpSelecionado === chaveOpcaoPncp(grupoIndex, opcaoIndex)"
                                                :class="{ 'is-selected': chaveObjetoPncpSelecionado === chaveOpcaoPncp(grupoIndex, opcaoIndex) }"
                                                @click="selecionarObjetoPncp(opcao, grupoIndex, opcaoIndex)">
                                            <span class="dfd-pncp-opcao-radio" aria-hidden="true"></span>
                                            <span class="dfd-pncp-opcao-conteudo">
                                                <span class="dfd-pncp-opcao-texto">{{ textoOpcaoPncp(opcao) }}</span>
                                                <a v-if="linkOpcaoPncp(opcao)"
                                                   class="dfd-pncp-opcao-link"
                                                   :href="linkOpcaoPncp(opcao)"
                                                   target="_blank"
                                                   rel="noopener noreferrer"
                                                   @click.stop>
                                                    Ver fonte
                                                </a>
                                                <span class="dfd-pncp-opcao-acao">
                                                    {{ chaveObjetoPncpSelecionado === chaveOpcaoPncp(grupoIndex, opcaoIndex) ? 'Selecionado' : 'Selecionar' }}
                                                </span>
                                            </span>
                                        </button>
                                    </div>
                                </section>
                            </template>
                        </div>
                        <div v-else class="dfd-painel-pncp-vazio">
                            <p class="mb-0">{{ mensagemVaziaPncp }}</p>
                            <span>Ajuste o objeto da contratação e tente novamente.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'
    import $ from 'jquery'
    import Swal from 'sweetalert2'

    export default {
        name: 'formDFD13303',
        components: { },
        data: function () {
            return {
                indexFormulario: 0,
                indexUltimaEtapaAvancada: 0,

                respostas: {
                    '23-0': '',
                    '23-1': '',
                    '24-0': '',
                    '25-0': '',
                    '25-1': '',
                    '26-0': '',
                    '26-1': '',
                    '27-0': '',
                    '27-1': '',
                    '28-0': '',
                    '28-1': '',
                    '29-0': '',
                    '29-1': '',
                    '30-0': '',
                    '30-1': '',
                    '46-0': '',
                    '46-1': '',
                },
                lstRespostaBanco: null,

                lstEtapas: [],
                itensDetalhados: null,

                temRequisicaoCompra: false,
                emProcessamento: false,
                flPodeCancelarProcessamento: false,
                cancelarProcessamentoLoading: false,
                intervaloStatus: null,
                painelPncpAberto: false,
                loadingPncp: false,
                lstObjetosPncp: [],
                gruposPncpAbertos: {},
                chaveObjetoPncpSelecionado: null,
                intervaloBuscaPncp: null,
                buscaPncpConcluida: false,
                mensagemVaziaPncp: 'Nenhum resultado encontrado no PNCP.',
            }
        },
        props: {
            idModeloArtefato: Number,
            idProcesso: Number,
            idProcessoModeloArtefato: Number,
            flPermissao: Boolean,
        },
        computed: {
            podeCancelarProcessamento() {
                return this.emProcessamento && this.flPodeCancelarProcessamento;
            },
            temResultadosPncp() {
                return (this.lstObjetosPncp || []).some(grupo =>
                    grupo && Array.isArray(grupo.resultados) && grupo.resultados.length > 0
                );
            },
        },
        methods: {
            validaCampo(valor) {
                if (this.lstRespostaBanco == null || this.lstRespostaBanco.length == 0) {
                    return false;
                } else {
                    return valor == '' || valor == undefined || valor == null;
                }
            },

            grupoPncpAberto(grupoIndex) {
                return !!(this.gruposPncpAbertos && this.gruposPncpAbertos[grupoIndex]);
            },

            alternarGrupoPncp(grupoIndex) {
                const aberto = this.grupoPncpAberto(grupoIndex);
                this.$set(this.gruposPncpAbertos, grupoIndex, !aberto);
            },

            resetarGruposPncpAbertos() {
                this.gruposPncpAbertos = {};
            },

            load() {
                this.indexFormulario = 0;
                this.indexUltimaEtapaAvancada = 0;
                this.respostas = {
                    '23-0': '',
                    '23-1': '',
                    '24-0': '',
                    '25-0': '',
                    '25-1': '',
                    '26-0': '',
                    '26-1': '',
                    '27-0': '',
                    '27-1': '',
                    '28-0': '',
                    '28-1': '',
                    '29-0': '',
                    '29-1': '',
                    '30-0': '',
                    '30-1': '',
                    '46-0': '',
                    '46-1': '',
                };
                this.lstRespostaBanco = null;
                this.lstEtapas = [];

                this.temRequisicaoCompra = false;
                this.getEtapas();
                this.carregaFormulario();
                this.getStatusProcessamento();
                this.verificarRequisicaoCompra();
            },

            getIdModeloArtefatoFormularioEtapa(cdEtapa) {
                return this.lstEtapas.find(x => x.cdEtapa == cdEtapa)?.idModeloArtefatoFormularioEtapa;
            },

            irParaProximaEtapa() {
                this.indexUltimaEtapaAvancada = this.indexFormulario + 1;
                this.indexFormulario += 1;
            },

            navegarParaEtapa(index) {
                this.indexFormulario = index;
                this.indexUltimaEtapaAvancada = this.indexFormulario;
            },


            salvaForm() {
                this.salvaFormulario(true);
            },

            salvaFormulario(exibirFeedback) {
                let $this = this;
                const formData = new FormData();
                if (Object.entries($this.respostas).length > 0 ){
                    var cont = 0;
                    Object.entries($this.respostas).forEach(([index, resposta]) => {
                        let idModeloArtefatoFormularioEtapa = index.split('-')[0];
                        let cdFormulario = index.split('-')[1];

                        let ModeloArtefatoFormularioEtapa = ($this.lstRespostaBanco || []).find(x => x.idModeloArtefatoFormularioEtapa == idModeloArtefatoFormularioEtapa && x.cdFormulario == cdFormulario);

                        formData.append('form[' + cont + '].idProcessoArtefatoFormularioResposta', (ModeloArtefatoFormularioEtapa ? ModeloArtefatoFormularioEtapa.idProcessoArtefatoFormularioResposta : 0));
                        formData.append('form[' + cont + '].idModeloArtefatoFormularioEtapa', idModeloArtefatoFormularioEtapa);
                        formData.append('form[' + cont + '].cdFormulario', cdFormulario);
                        if (resposta != undefined && resposta.trim() != '') {
                            formData.append('form[' + cont + '].dsResposta', resposta);
                        }
                        formData.append('form[' + cont + '].idProcesso', $this.idProcesso);
                        formData.append('form[' + cont + '].idProcessoModeloArtefato', $this.idProcessoModeloArtefato);
                        formData.append('form[' + cont + '].dsPergunta', $('#pergunta-' + index).text());

                        cont++;
                    });

                } else {
                    avisoErro("Preencha o formulário");
                    return Promise.resolve(false);
                }

                return axios.post(`${urlApi}/ProcessoArtefatoFormulario/Post`, formData, { headers: { "Content-Type": `multipart/form-data; boundary=${formData._boundary}`, } })
                    .then(res => {
                        if (res.data.success) {
                            if (exibirFeedback) {
                                avisoToast("Formulário registrado com sucesso.");
                                $this.load();
                            }
                            return true;
                        } else {
                            avisoErro("Não foi possível enviar o artefato.");
                            return false;
                        }
                    })
                    .catch(res => {
                        $this.msgErro = 'Não foi possível enviar o artefato.';
                        if (res.response && res.response.data) {
                            $this.msgErro = res.response.data.msg + " - " + res.response.data.errors[0];
                            avisoErro(res.response.data.msg + " - " + res.response.data.errors[0]);
                        } else {
                            avisoErro("Não foi possível enviar o artefato.");
                        }
                        return false;
                    });
            },

            carregaFormulario() {
                let $this = this;
                axios.get(`${urlApi}/ProcessoArtefatoFormulario/Get/`, { showLoading: true, params: { idProcesso: $this.idProcesso, idProcessoModeloArtefato: $this.idProcessoModeloArtefato } })
                    .then(res => {
                        if (res.data.success) {
                            var result = res.data.data;
                            $this.lstRespostaBanco = result;
                            for (let i = 0; i < result.length; i++) {
                                let item = result[i];
                                //$this.respostas[item.idModeloArtefatoFormularioEtapa + '-' + item.cdFormulario] = item.dsResposta;
                                $this.$set($this.respostas, item.idModeloArtefatoFormularioEtapa + '-' + item.cdFormulario, (item.dsResposta == null ? '' : item.dsResposta));
                            }
                            $this.getItensDetalhados();
                        } else {
                            avisoErro("Não foi possível carregar os dados do formulário.");
                        }
                    })
                    .catch(res => {
                        if (res.response.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro("Não foi possível carregar os dados do formulário.");
                        }
                    });
            },

            getEtapas() {
                let $this = this;

                axios.get(`${urlApi}/ProcessoArtefatoFormulario/GetEtapas/`, { showLoading: true, params: { idModeloArtefato: $this.idModeloArtefato } })
                    .then(res => {
                        $this.lstProcessoArtefatoHistorico = null;
                        if (res.data.success) {
                            var result = res.data.data;

                            $this.lstEtapas = result;

                        } else {
                            avisoErro("Não foi possível carregar as etapas.");
                        }
                    })
                    .catch(res => {
                        if (res.response.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro("Não foi possível carregar as etapas.");
                        }
                    });
            },

            getItensDetalhados() {
                let $this = this;
                return axios.get(`${urlApi}/ProcessoItem/GetItensDetalhados`, {
                    params: { idProcesso: this.idProcesso }
                })
                    .then(res => {
                        if (res.data && res.data.data && res.data.data.rows) {
                            $this.itensDetalhados = res.data.data.rows;

                            if ($this.itensDetalhados.length > 0) {
                                var descricaoQuantidade = '';
                                //var descricaoItens = '';
                                var loteUnico = true;
                                var loteAtual = undefined;
                                var valorTotalSomado = 0;
                                var itensComValor = 0;
                                $this.itensDetalhados.forEach((item) => {
                                    if (loteAtual == undefined) {
                                        loteAtual = item.lote;
                                    }
                                    if (loteAtual != item.lote) {
                                        loteUnico = false;
                                    }
                                    loteAtual = item.lote;
                                });

                                $this.itensDetalhados.forEach((item) => {
                                    descricaoQuantidade += ''
                                        + item.nome +
                                        (!loteUnico ? ' - Lote: ' + item.lote : '') +
                                        ' - Quantidade: ' + (item.qtdItemCriacao > 0 ? $this.formatarNumero(item.qtdItemCriacao) : $this.formatarNumero(item.quantidade)) + +
                                        ' - Unidade de Medida: ' + item.unidadeMedida +
                                        ' ; \n';

                                    //descricaoItens += ' '
                                    //    + item.nome +
                                    //    (!loteUnico ? ' - Lote: ' + item.lote : '') +
                                    //    ' - Quantidade: ' + $this.formatarNumero(item.quantidade) +
                                    //    ' - Unidade de Medida: ' + item.unidadeMedida +
                                    //    ' - Valor Unitário: R$ ' + $this.formatarNumero(item.valorUnitario) +
                                    //    ' - Valor Total: R$ ' + $this.formatarNumero(item.valorTotal) +
                                    //    (item.nmUnidade != "" && item.nmUnidade != null ? ' - Unidade Responsável: ' + item.nmUnidade : '') +
                                    //    (item.dtDesejadaItem != "" && item.dtDesejadaItem != null ? ' - Data desejada: ' + this.formatarData(item.dtDesejadaItem) : '') +
                                    //    (item.dsGrauPrioridade != "" && item.dsGrauPrioridade != null ? ' - Grau de prioridade: ' + item.dsGrauPrioridade : '') +
                                    //    (item.flEnvolvePostoTrabalho != "" && item.flEnvolvePostoTrabalho != null ? ' - Envolve posto de trabalho: ' + (item.flEnvolvePostoTrabalho == 1 ? 'Sim' : 'Não') : '') +
                                    //    (item.nrProcessoContratacao != "" && item.nrProcessoContratacao != null ? ' - Número do processo de contratação: ' + item.nrProcessoContratacao : '') +
                                    //    (item.nrProcessoVinculacao != "" && item.nrProcessoVinculacao != null ? ' - Vinculação a outras contratações: ' + item.nrProcessoVinculacao : '') +
                                    //    (item.dsJustificativa != "" && item.dsJustificativa != null ? ' - Justificativa: ' + item.dsJustificativa : '') +
                                    //    ' ; \n';

                                    if (!(item.flValorSigiloso === true || item.flValorSigiloso === 1)) {
                                        itensComValor++;
                                        valorTotalSomado += item.valorTotal;
                                    }
                                });
                                if ($this.respostas[$this.getIdModeloArtefatoFormularioEtapa(25) + '-0'] == '') {
                                    $this.$set($this.respostas, $this.getIdModeloArtefatoFormularioEtapa(25) + '-0', descricaoQuantidade);
                                }

                                if ($this.respostas[$this.getIdModeloArtefatoFormularioEtapa(26) + '-0'] == '') {
                                    var textoEstimativa = itensComValor === 0
                                        ? 'sigiloso'
                                        : ('R$ ' + $this.formatarNumero(valorTotalSomado));
                                    $this.$set($this.respostas, $this.getIdModeloArtefatoFormularioEtapa(26) + '-0', textoEstimativa);
                                }
                            }
                        } else {
                            avisoErro("Não foi possível carregar os itens do processo.");
                        }
                    })
                    .catch(() => {
                        avisoErro("Erro ao buscar os itens do processo.");
                    });
            },

            formatarNumero(valor, casasDecimais = 2) {
                if (typeof valor !== 'number') {
                    valor = parseFloat(valor);
                }
                if (isNaN(valor)) return '';

                return valor.toLocaleString('pt-BR', {
                    minimumFractionDigits: casasDecimais,
                    maximumFractionDigits: casasDecimais,
                });
            },

            formatarData(valor) {
                if (!valor) return ''
                const d = new Date(valor)
                return d.toLocaleDateString('pt-BR')
            },

            buscarNoPncp() {
                this.painelPncpAberto = true;
                this.loadingPncp = true;
                this.lstObjetosPncp = [];
                this.chaveObjetoPncpSelecionado = null;
                this.buscaPncpConcluida = false;
                this.mensagemVaziaPncp = 'Nenhum resultado encontrado no PNCP.';
                this.pararMonitoramentoBuscaPncp();

                axios.get(`${urlApi}/ProcessoBuscaPNCP/Get`, {
                    showLoading: false,
                    params: { idProcesso: this.idProcesso, idProcessoModeloArtefato: this.idProcessoModeloArtefato },
                })
                    .then(res => {
                        if (!res.data || !res.data.success) {
                            this.iniciarNovaBuscaPncp();
                            return;
                        }

                        const data = res.data.data || {};
                        const busca = data.ProcessoBuscaPNCP || data.processoBuscaPNCP;

                        if (!busca) {
                            this.iniciarNovaBuscaPncp();
                            return;
                        }

                        const dsResposta = busca.dsResposta;
                        if (dsResposta == null || dsResposta === '') {
                            this.loadingPncp = true;
                            this.buscaPncpConcluida = false;
                            this.iniciarMonitoramentoBuscaPncp();
                            return;
                        }

                        this.aplicarResultadoBuscaPncp(data, dsResposta);
                    })
                    .catch(() => {
                        this.iniciarNovaBuscaPncp();
                    });
            },

            buscarNovamentePncp() {
                this.buscaPncpConcluida = false;
                this.chaveObjetoPncpSelecionado = null;
                this.iniciarNovaBuscaPncp();
            },

            iniciarNovaBuscaPncp() {
                const dsObjeto = (this.respostas[this.getIdModeloArtefatoFormularioEtapa(24) + '-0'] || '').trim();
                if (!dsObjeto) {
                    this.loadingPncp = false;
                    avisoErro('Preencha o objeto da contratação antes de buscar no PNCP.');
                    return;
                }

                this.loadingPncp = true;
                this.lstObjetosPncp = [];
                this.buscaPncpConcluida = false;

                axios.post(`${urlApi}/ProcessoBuscaPNCP/buscaObjetoPncp`, {
                    dsObjeto,
                    idProcesso: this.idProcesso,
                    idProcessoModeloArtefato: this.idProcessoModeloArtefato,
                }, { showLoading: false })
                    .then(res => {
                        if (res.data && res.data.success) {
                            this.iniciarMonitoramentoBuscaPncp();
                            this.getStatusBuscaPncp();
                        } else {
                            this.loadingPncp = false;
                            avisoErro((res.data && res.data.msg) || 'Não foi possível buscar no PNCP.');
                        }
                    })
                    .catch(err => {
                        this.loadingPncp = false;
                        const msg = (err.response && err.response.data && err.response.data.errors && err.response.data.errors[0])
                            || (err.response && err.response.data && err.response.data.msg)
                            || err.message
                            || 'Não foi possível buscar no PNCP.';
                        avisoErro(msg);
                    });
            },

            aplicarResultadoBuscaPncp(data, dsResposta) {
                this.loadingPncp = false;
                this.buscaPncpConcluida = true;
                this.pararMonitoramentoBuscaPncp();
                this.resetarGruposPncpAbertos();

                if (typeof dsResposta === 'string' && dsResposta.trim() === 'Não foi possível realizar busca') {
                    this.lstObjetosPncp = [];
                    this.mensagemVaziaPncp = 'Não foram encontradas respostas no PNCP.';
                    return;
                }

                const formatada = data.dsRepostaFormatada
                    || data.dsRespostaFormatada
                    || [];

                this.lstObjetosPncp = Array.isArray(formatada) ? formatada : [];
                this.mensagemVaziaPncp = 'Nenhum resultado encontrado no PNCP.';
            },

            getStatusBuscaPncp() {
                axios.get(`${urlApi}/ProcessoBuscaPNCP/Get`, {
                    showLoading: false,
                    params: { idProcesso: this.idProcesso, idProcessoModeloArtefato: this.idProcessoModeloArtefato },
                })
                    .then(res => {
                        if (!res.data || !res.data.success) {
                            return;
                        }

                        const data = res.data.data || {};
                        const busca = data.ProcessoBuscaPNCP || data.processoBuscaPNCP;
                        if (!busca) {
                            this.loadingPncp = false;
                            this.lstObjetosPncp = [];
                            this.pararMonitoramentoBuscaPncp();
                            return;
                        }

                        const dsResposta = busca.dsResposta;
                        if (dsResposta == null || dsResposta === '') {
                            this.loadingPncp = true;
                            return;
                        }

                        this.aplicarResultadoBuscaPncp(data, dsResposta);
                    })
                    .catch(() => {
                        // Mantém o polling em caso de falha pontual.
                    });
            },

            iniciarMonitoramentoBuscaPncp() {
                if (this.intervaloBuscaPncp) return;
                this.intervaloBuscaPncp = setInterval(() => {
                    this.getStatusBuscaPncp();
                }, 5000);
            },

            pararMonitoramentoBuscaPncp() {
                if (!this.intervaloBuscaPncp) return;
                clearInterval(this.intervaloBuscaPncp);
                this.intervaloBuscaPncp = null;
            },

            formatarNomeGrupoPncp(nome) {
                const mapa = {
                    sugestoes_objeto: 'Sugestões de objeto',
                    sugestoes_itens: 'Sugestões de itens',
                    levantamento_mercado: 'Levantamento de mercado',
                };
                if (!nome) return 'Resultados';
                if (mapa[nome]) return mapa[nome];
                return String(nome)
                    .replace(/_/g, ' ')
                    .replace(/\b\w/g, (letra) => letra.toUpperCase());
            },

            chaveOpcaoPncp(grupoIndex, opcaoIndex) {
                return `${grupoIndex}-${opcaoIndex}`;
            },

            textoOpcaoPncp(opcao) {
                if (typeof opcao === 'string') return opcao;
                if (!opcao || typeof opcao !== 'object') return '';
                return opcao.resultado || opcao.texto || '';
            },

            linkOpcaoPncp(opcao) {
                if (!opcao || typeof opcao !== 'object') return '';
                return opcao.url || opcao.link || '';
            },

            selecionarObjetoPncp(opcao, grupoIndex, opcaoIndex) {
                const chave = this.getIdModeloArtefatoFormularioEtapa(24) + '-0';
                this.$set(this.respostas, chave, this.textoOpcaoPncp(opcao));
                this.chaveObjetoPncpSelecionado = this.chaveOpcaoPncp(grupoIndex, opcaoIndex);
                avisoToast('Objeto selecionado do PNCP.', 'success');
            },

            fecharPainelPncp() {
                this.pararMonitoramentoBuscaPncp();
                this.painelPncpAberto = false;
                this.loadingPncp = false;
                this.lstObjetosPncp = [];
                this.chaveObjetoPncpSelecionado = null;
                this.buscaPncpConcluida = false;
            },

            verificarRequisicaoCompra() {
                if (!this.idProcesso) {
                    this.temRequisicaoCompra = false;
                    return;
                }

                axios.get(`${urlApi}/RequisicaoCompra/GetPorProcesso`, {
                    showLoading: false,
                    params: { idProcesso: this.idProcesso },
                })
                    .then(res => {
                        const idRequisicaoCompra = res.data && res.data.success && res.data.data
                            ? res.data.data.idRequisicaoCompra
                            : 0;
                        this.temRequisicaoCompra = idRequisicaoCompra > 0;
                    })
                    .catch(() => {
                        this.temRequisicaoCompra = false;
                    });
            },

            async preencherIA() {
                let $this = this;
                const podeGerar = await this.verificaItens();
                if (!podeGerar) return;

                Swal.fire({
                    title: 'Confirmar geração das respostas por IA',
                    html: `Esta ação utilizará inteligência artificial para gerar automaticamente as respostas com base nos documentos enviados.<br><br> Caso o formulário já tenha sido preenchido, as respostas existentes serão substituídas.<br><br>
Deseja continuar?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#1f7bff',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, gerar por IA',
                    cancelButtonText: 'Cancelar'

                }).then(async (result) => {
                    if (result.isConfirmed) {
                        const salvou = await $this.salvaFormulario(false);
                        if (!salvou) return;

                        axios.post(`${urlApi}/ProcessoArtefatoFormulario/PreencherIA/`, { idProcesso: this.idProcesso, idProcessoModeloArtefato: $this.idProcessoModeloArtefato })
                            .then(res => {
                                if (res.data.success) {
                                    $this.load();
                                } else {
                                    avisoErro("Não foi possível carregar as respostas.");
                                }
                            })
                            .catch(() => {
                                avisoErro("Não foi possível carregar as respostas.");
                            });
                    }
                });

            },

            async preencherPorRequisicao() {
                let $this = this;
                const podeGerar = await this.verificaItensPorRequisicao();
                if (!podeGerar) return;

                Swal.fire({
                    title: 'Confirmar preenchimento a partir da requisição',
                    html: `Esta ação utilizará a requisição de compra vinculada para gerar automaticamente as respostas.<br><br> Caso o formulário já tenha sido preenchido, as respostas existentes serão substituídas.<br><br>
Deseja continuar?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#1f7bff',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, preencher',
                    cancelButtonText: 'Cancelar'

                }).then(async (result) => {
                    if (result.isConfirmed) {
                        const salvou = await $this.salvaFormulario(false);
                        if (!salvou) return;

                        axios.post(`${urlApi}/ProcessoArtefatoFormulario/PreencherPorRequisicao/`, { idProcesso: this.idProcesso, idProcessoModeloArtefato: $this.idProcessoModeloArtefato })
                            .then(res => {
                                if (res.data.success) {
                                    $this.load();
                                } else {
                                    avisoErro("Não foi possível carregar as respostas.");
                                }
                            })
                            .catch(() => {
                                avisoErro("Não foi possível carregar as respostas.");
                            });
                    }
                });

            },

            getStatusProcessamento(showLoading = true) {
                axios.get(`${urlApi}/ProcessoArtefatoFormulario/GetStatusProcessamento/`, { showLoading: showLoading, params: { idProcesso: this.idProcesso, idProcessoModeloArtefato: this.idProcessoModeloArtefato } })
                    .then(res => {
                        if (res.data.success) {
                            var result = res.data.data;

                            this.emProcessamento = false;
                            this.flPodeCancelarProcessamento = false;
                            if (result && result.idProcessoArtefatoFormularioProcessamento) {
                                const emAndamento = typeof result.emAndamento === 'boolean'
                                    ? result.emAndamento
                                    : (result.dsStatus != 'Finalizada' && result.dsStatus != 'Cancelada');
                                if (emAndamento) {
                                    this.emProcessamento = true;
                                    this.flPodeCancelarProcessamento = !!result.flPodeCancelar;
                                    this.iniciarMonitoramentoStatus();
                                } else {
                                    this.emProcessamento = false;
                                    this.pararMonitoramentoStatus();
                                    this.carregaFormulario();
                                }
                            } else {
                                this.emProcessamento = false;
                                this.pararMonitoramentoStatus();
                                this.carregaFormulario();
                            }

                        } else {
                            avisoErro("Não foi possível carregar status do processamento.");
                        }
                    })
                    .catch(() => {
                        avisoErro("Não foi possível carregar status do processamento.");
                    });
            },

            confirmarCancelarProcessamento() {
                Swal.fire({
                    title: 'Cancelar processamento?',
                    html: 'O preenchimento com IA em andamento será cancelado por possível travamento. Depois você poderá tentar novamente.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d97706',
                    cancelButtonText: 'Voltar',
                    confirmButtonText: 'Sim, cancelar processamento',
                    reverseButtons: true,
                }).then(result => {
                    if (result.isConfirmed) this.cancelarProcessamentoTravado();
                });
            },

            cancelarProcessamentoTravado() {
                if (this.cancelarProcessamentoLoading) return;
                this.cancelarProcessamentoLoading = true;
                axios.post(`${urlApi}/ProcessoArtefatoFormulario/CancelarProcessamentoTravado`, {
                    idProcesso: this.idProcesso,
                    idProcessoModeloArtefato: this.idProcessoModeloArtefato,
                }, { showLoading: true })
                    .then(res => {
                        if (res.data && res.data.success) {
                            avisoToast(res.data.msg || 'Processamento cancelado com sucesso.', 'success');
                            this.emProcessamento = false;
                            this.flPodeCancelarProcessamento = false;
                            this.pararMonitoramentoStatus();
                            this.getStatusProcessamento(false);
                        } else {
                            avisoErro((res.data && res.data.msg) || 'Não foi possível cancelar o processamento.');
                        }
                    })
                    .catch(err => {
                        const msg = (err.response && err.response.data && err.response.data.errors && err.response.data.errors[0])
                            || (err.response && err.response.data && err.response.data.msg)
                            || err.message
                            || 'Não foi possível cancelar o processamento.';
                        avisoErro(msg);
                    })
                    .finally(() => {
                        this.cancelarProcessamentoLoading = false;
                    });
            },
            iniciarMonitoramentoStatus() {
                if (this.intervaloStatus) return;

                this.intervaloStatus = setInterval(() => {
                    this.getStatusProcessamento(false);
                }, 10000);
            },

            pararMonitoramentoStatus() {
                if (!this.intervaloStatus) return;

                clearInterval(this.intervaloStatus);
                this.intervaloStatus = null;
            },

            verificaItens() {
                return axios.get(`${urlApi}/ProcessoItem/GetItensDetalhados`, {
                    params: { idProcesso: this.idProcesso }
                })
                    .then(res => {
                        if (res.data && res.data.data && res.data.data.rows) {
                            var itensDetalhados = res.data.data.rows;

                            if (itensDetalhados.length === 0) {
                                avisoErro("Para realizar a geração por IA, é necessário o cadastro dos itens do processo.");
                                return false;
                            }

                            return true;
                        } else {
                            avisoErro("Não foi possível carregar os itens do processo.");
                            return false;
                        }
                    })
                    .catch(() => {
                        avisoErro("Erro ao buscar os itens do processo.");
                        return false;
                    });
            },

            verificaItensPorRequisicao() {
                return axios.get(`${urlApi}/ProcessoItem/GetItensDetalhados`, {
                    params: { idProcesso: this.idProcesso }
                })
                    .then(res => {
                        if (res.data && res.data.data && res.data.data.rows) {
                            var itensDetalhados = res.data.data.rows;

                            if (itensDetalhados.length === 0) {
                                avisoErro("Para preencher a partir da requisição, é necessário o cadastro dos itens do processo.");
                                return false;
                            }

                            return true;
                        } else {
                            avisoErro("Não foi possível carregar os itens do processo.");
                            return false;
                        }
                    })
                    .catch(() => {
                        avisoErro("Erro ao buscar os itens do processo.");
                        return false;
                    });
            },
        },
        mounted: function () {
            this.load();
        },
        beforeDestroy: function () {
            this.pararMonitoramentoBuscaPncp();
            this.pararMonitoramentoStatus();
        },
        watch: {
            idModeloArtefato: function () {
                this.load();
            },
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .border-danger {
        border-color: #E8B6C1 !important;
        box-shadow: 0 0 0 0.2rem rgba(196, 104, 110, 0.25);
    }
    .importacao-em-andamento-container {
        display: flex;
        justify-content: center;
        align-items: center;
        /*min-height: calc(100vh - 260px);*/
        padding: 28px 16px 0px;
    }

    .importacao-em-andamento-card {
        width: 100%;
        max-width: 100%;
        background: #ffffff;
        border-radius: 18px;
        border: 1px solid rgba(226, 232, 240, 0.95);
        box-shadow: 0 16px 42px rgba(15, 23, 42, 0.08);
        padding: 20px 15px;
        text-align: center;
    }

    .importacao-em-andamento-icon {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        margin: 0 auto 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        color: #ffffff;
        animation: pulseImportacao 1.8s ease-in-out infinite;
    }

    .importacao-em-andamento-card h2 {
        margin: 0 0 8px;
        font-size: 1.6rem;
        font-weight: 700;
        color: #0f172a;
    }

    .importacao-em-andamento-card p {
        /*margin: 0 auto;*/
        max-width: 620px;
        font-size: 1rem;
        color: #475569;
    }

    .importacao-em-andamento-actions {
        /*margin-top: 20px;*/
        /*margin-bottom: 8px;*/
        display: flex;
        justify-content: center;
    }

    .importacao-em-andamento-card small {
        display: block;
        margin-top: 2px;
        color: #64748b;
        font-size: 0.86rem;
    }

    .dfd-conteudo {
        display: flex;
        align-items: flex-start;
        gap: 1rem;
        width: 100%;
    }

    .dfd-conteudo--com-pncp {
        position: relative;
        display: block;
    }

    .dfd-formulario {
        width: 100%;
        min-width: 0;
        transition: width 0.25s ease;
    }

    .dfd-conteudo--com-pncp .dfd-formulario {
        width: calc(60% - 0.5rem);
    }

    .dfd-painel-pncp {
        width: 40%;
        flex: 0 0 40%;
        min-height: 280px;
        display: flex;
        flex-direction: column;
        border: 1px solid rgba(226, 232, 240, 0.95);
        border-radius: 14px;
        background: #ffffff;
        box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
        overflow: hidden;
    }

    .dfd-conteudo--com-pncp .dfd-painel-pncp {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: calc(40% - 0.5rem);
        min-height: 0;
        height: auto;
    }

    .dfd-painel-pncp-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 12px;
        padding: 16px 16px 12px;
        border-bottom: 1px solid #eef2f7;
        background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
        flex-shrink: 0;
    }

    .dfd-painel-pncp-titulo {
        margin: 0;
        font-size: 0.98rem;
        font-weight: 700;
        color: #0f172a;
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .dfd-painel-pncp-header-spinner {
        width: 0.9rem;
        height: 0.9rem;
        border-width: 0.15em;
        flex-shrink: 0;
    }

    .dfd-painel-pncp-subtitulo {
        margin: 4px 0 0;
        font-size: 0.82rem;
        color: #64748b;
    }

    .dfd-painel-pncp-acoes {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-shrink: 0;
    }

    .dfd-painel-pncp-fechar {
        width: 32px;
        height: 32px;
        border: none;
        border-radius: 8px;
        background: transparent;
        color: #64748b;
        font-size: 1.4rem;
        line-height: 1;
        cursor: pointer;
        flex-shrink: 0;
        transition: background 0.15s ease, color 0.15s ease;
    }

    .dfd-painel-pncp-fechar:hover {
        background: #f1f5f9;
        color: #0f172a;
    }

    .dfd-painel-pncp-loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        flex: 1 1 auto;
        min-height: 0;
        padding: 32px 16px 24px;
        color: #475569;
        text-align: center;
    }

    .dfd-painel-pncp-resultado {
        flex: 1 1 auto;
        min-height: 0;
        padding: 12px;
        overflow-y: auto;
    }

    .dfd-pncp-grupos {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .dfd-pncp-grupo {
        border: 1px solid #e2e8f0;
        border-radius: 12px;
        background: #fff;
        overflow: hidden;
    }

    .dfd-pncp-grupo-titulo {
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
        margin: 0;
        padding: 12px 14px;
        border: 0;
        background: #f8fafc;
        font-size: 0.8rem;
        font-weight: 700;
        letter-spacing: 0.02em;
        text-transform: uppercase;
        text-align: left;
        color: #64748b;
        cursor: pointer;
        transition: background 0.15s ease, color 0.15s ease;
    }

    .dfd-pncp-grupo-titulo:hover {
        background: #f1f5f9;
        color: #475569;
    }

    .dfd-pncp-grupo.is-open .dfd-pncp-grupo-titulo {
        color: #334155;
        border-bottom: 1px solid #e2e8f0;
    }

    .dfd-pncp-grupo-titulo-texto {
        flex: 1 1 auto;
        min-width: 0;
    }

    .dfd-pncp-grupo-meta {
        flex: 0 0 auto;
        min-width: 22px;
        padding: 2px 7px;
        border-radius: 999px;
        background: #e2e8f0;
        color: #475569;
        font-size: 0.72rem;
        font-weight: 700;
        line-height: 1.2;
        text-align: center;
    }

    .dfd-pncp-grupo-chevron {
        flex: 0 0 auto;
        width: 8px;
        height: 8px;
        border-right: 2px solid #94a3b8;
        border-bottom: 2px solid #94a3b8;
        transform: rotate(45deg);
        transition: transform 0.15s ease;
        margin-left: 2px;
    }

    .dfd-pncp-grupo.is-open .dfd-pncp-grupo-chevron {
        transform: rotate(-135deg);
        margin-top: 4px;
    }

    .dfd-pncp-lista {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 10px;
        max-height: min(320px, 45vh);
        overflow-x: hidden;
        overflow-y: auto;
        overscroll-behavior: contain;
        -webkit-overflow-scrolling: touch;
    }

    .dfd-pncp-opcao {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        width: 100%;
        text-align: left;
        padding: 12px 14px;
        border: 1px solid #e2e8f0;
        border-radius: 12px;
        background: #fff;
        color: #1e293b;
        cursor: pointer;
        transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
    }

    .dfd-pncp-opcao:hover {
        border-color: #93c5fd;
        background: #f8fbff;
        box-shadow: 0 4px 14px rgba(37, 99, 235, 0.08);
        transform: translateY(-1px);
    }

    .dfd-pncp-opcao:focus-visible {
        outline: 2px solid #2563eb;
        outline-offset: 2px;
    }

    .dfd-pncp-opcao.is-selected {
        border-color: #2563eb;
        background: #eff6ff;
        box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.2);
    }

    .dfd-pncp-opcao-radio {
        width: 18px;
        height: 18px;
        margin-top: 2px;
        border: 2px solid #cbd5e1;
        border-radius: 50%;
        flex-shrink: 0;
        transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
    }

    .dfd-pncp-opcao:hover .dfd-pncp-opcao-radio {
        border-color: #60a5fa;
    }

    .dfd-pncp-opcao.is-selected .dfd-pncp-opcao-radio {
        border-color: #2563eb;
        background: #2563eb;
        box-shadow: inset 0 0 0 3px #eff6ff;
    }

    .dfd-pncp-opcao-conteudo {
        display: flex;
        flex-direction: column;
        gap: 6px;
        min-width: 0;
        flex: 1;
    }

    .dfd-pncp-opcao-texto {
        font-size: 0.92rem;
        line-height: 1.45;
        color: #0f172a;
        word-break: break-word;
    }

    .dfd-pncp-opcao-link {
        font-size: 0.8rem;
        font-weight: 600;
        color: #2563eb;
        text-decoration: none;
        width: fit-content;
    }

    .dfd-pncp-opcao-link:hover {
        text-decoration: underline;
    }

    .dfd-pncp-opcao-acao {
        font-size: 0.75rem;
        font-weight: 600;
        letter-spacing: 0.01em;
        color: #64748b;
        text-transform: uppercase;
    }

    .dfd-pncp-opcao:hover .dfd-pncp-opcao-acao {
        color: #2563eb;
    }

    .dfd-pncp-opcao.is-selected .dfd-pncp-opcao-acao {
        color: #1d4ed8;
    }

    .dfd-painel-pncp-vazio {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 6px;
        min-height: 100%;
        padding: 24px 16px;
        text-align: center;
        color: #64748b;
        font-size: 0.9rem;
    }

    .dfd-painel-pncp-vazio span {
        font-size: 0.8rem;
        color: #94a3b8;
    }
</style>

